















































import Vue from "vue";
import ThemeImg from "@/components/ThemeImg.vue";
import DepartmentsGrid from "./DepartmentsGrid.vue";
import UnManagedSection from "./UnManagedSection.vue";
import Processing from "@/components/table/Processing.vue";
import { state } from "./data/state";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  components: {
    DepartmentsGrid,
    UnManagedSection,
    ThemeImg,
    Processing,
  },
  setup() {
    const {
      is_loading_all,
      selected_entity_type,
      current_display_list_without_filtering,
    } = state;

    const has_no_results = computed(
      () =>
        !is_loading_all.value &&
        current_display_list_without_filtering.value.length === 0
    );

    return {
      is_loading_all,
      has_no_results,
      selected_entity_type,
    };
  },
});
